import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardLabelContainer = (props: Props) => {
  const { children, withMinHeight } = props;

  const containerStyles = [styles.container, withMinHeight && styles.containerWithMinHeight];

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['2'],
  },
  containerWithMinHeight: {
    minHeight: 60,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  withMinHeight?: boolean;
}>;
